<template>
	<div>
		<div class="modal fade" id="MdComiVend">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-body">
						<div
							class="modal-header"
							style="
								display: flex;
								justify-content: space-between;
							"
						>
							<h4 class="modal-title pull-left">
								CONTROLE DE COMISSÃO DE VENDAS
							</h4>
							<div class="pull-right col-xs-3">
								<div class="input-group">
									<span class="input-group-addon">Ano</span>
									<select v-model="ano" class="form-control">
										<option
											v-for="(y, index) in 10"
											:key="index"
											:value="2015 + y"
										>
											{{ 2015 + y }}
										</option>
									</select>
								</div>
							</div>

							<transition name="fade" mode="out-in">
								<button
									:id="
										parcelasAgrupadas
											? 'desagruparParcelas'
											: 'agruparParcelas'
									"
									@click="agruparParcelas()"
									class="btn btn-sm btn-info"
									:key="parcelasAgrupadas"
								>
									{{
										parcelasAgrupadas
											? 'Desagrupar Vendas'
											: 'Agrupar Vendas'
									}}
								</button>
							</transition>
							<button
								id="getPDF"
								@click="gerar('pdf')"
								class="btn btn-sm btn-info"
							>
								Gerar PDF
							</button>
							<button
								id="getXLS"
								@click="gerar('xls')"
								class="btn btn-sm btn-info"
							>
								Gerar XLS
							</button>
						</div>

						<div class="row">
							<div class="pull-right col-xs-3">
								<div class="input-group">
									<span class="input-group-addon"
										>Situação</span
									>
									<select
										v-model="situacao"
										class="form-control"
									>
										<option value="todos">Todos</option>
										<option value="novo">Novo</option>
										<option value="renovado">
											Renovado
										</option>
									</select>
								</div>
							</div>
						</div>

						<div class="item-component">
							<div class="clearfix"></div>
							<br />
							<div class="col-xs-12">
								<CntComissao
									v-if="comissao != null && contratos != null"
									:ano="ano"
									:dataIn="{ com: comissao, con: contratos }"
									:parcelasAgrupadas="parcelasAgrupadas"
									:situacao="situacao"
								/>
							</div>
							<div class="clearfix"></div>
							<br />
						</div>
						<div class="clearfix"></div>
						<br />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import CntComissao from './ctrl.comissao.vue';
	import WBS from 'js/http';
	import toastr from 'toastr';
	import pdfMake from 'pdfmake/build/pdfmake';
	import pdfFonts from 'pdfmake/build/vfs_fonts';
	pdfMake.vfs = pdfFonts.pdfMake.vfs;
	const XLSX = require('xlsx');

	let iniDate = new Date();
	iniDate.setMonth(iniDate.getMonth() - 1);

	export default {
		name: 'ModalComissaoVendedores',
		components: { CntComissao },
		data() {
			return {
				comissao: null,
				contratos: null,
				vendedor: null,
				contratosNoAno: [],
				ano: new Date().getFullYear(),
				parcelasAgrupadas: null,
				situacao: 'todos',
			};
		},
		methods: {
			open(data) {
				WBS.send('protected-custom-commission', data, (resp) => {
					if (resp.status == 'success') {
						this.contratos = resp.data;
						this.comissao = data.comissao;
						this.vendedor = data.vendedor;
						$('#MdComiVend').modal('show');
					} else {
						toastr.error(resp.msgs[0]);
					}
				});
			},
			agruparParcelas() {
				this.parcelasAgrupadas = !this.parcelasAgrupadas;
			},
			gerar(tipo) {
				// Define os tamanhos das fontes para a tabela no PDF
				const bodyTableFontSize = 8;
				const firstHeaderFontSize = 14;
				const secondHeaderFontSize = 10;

				// Filtra os contratos por ano
				this.contratosNoAno = [];
				this.contratos.forEach((item) => {
					if (item.TotalContrato !== null) {
						if (item.data && item.TotalContrato !== null) {
							if (
								this.ano === parseInt(item.data.split('-')[0])
							) {
								this.contratosNoAno.push(item);
							}
						} else {
							if (
								this.ano ===
								parseInt(item[0].data.split('-')[0])
							) {
								this.contratosNoAno.push(item);
							}
						}
					}
				});

				// Pega o nome do vendedor
				const vendedor = this.vendedor;

				// Monta as linhas das empresas com os faturamentos mês a mês
				let faturamentoEmpresas = [];
				if (this.contratosNoAno.length > 0) {
					faturamentoEmpresas = [];
					this.contratosNoAno.forEach((item) => {
						let fat = [];
						let i = 1;

						fat.push({
							text: item.cnpj.razao_social,
							fontSize: bodyTableFontSize,
						});
						for (i = 1; i <= 12; i++) {
							if (item.data) {
								if (
									i >= parseInt(item.data.split('-')[1]) &&
									i <
										parseInt(item.data.split('-')[1]) +
											(this.parcelasAgrupadas ||
												parseInt(item.parcelas))
								) {
									fat.push({
										text: (
											item.valor /
											(this.parcelasAgrupadas ||
												parseInt(item.parcelas))
										).toFixed(2),
										fontSize: bodyTableFontSize,
									});
								} else {
									fat.push({
										text: ' - ',
										fontSize: bodyTableFontSize,
									});
								}
							} else {
								if (
									i >= parseInt(item[0].data.split('-')[1]) &&
									i <
										parseInt(item[0].data.split('-')[1]) +
											parseInt(item.parcelas)
								) {
									fat.push({
										text: (
											item.valor / parseInt(item.parcelas)
										).toFixed(2),
										fontSize: bodyTableFontSize,
									});
								} else {
									fat.push({
										text: ' - ',
										fontSize: bodyTableFontSize,
									});
								}
							}
						}
						faturamentoEmpresas.push(fat);
					});
				}

				// Soma as colunas dos meses e totaliza o faturamento do mês
				let fatMes = [
					'Faturamento',
					'0.00',
					'0.00',
					'0.00',
					'0.00',
					'0.00',
					'0.00',
					'0.00',
					'0.00',
					'0.00',
					'0.00',
					'0.00',
					'0.00',
				];
				if (faturamentoEmpresas.length > 0) {
					fatMes = [];
					faturamentoEmpresas.forEach((empresa) => {
						empresa.map((line, index) => {
							if (fatMes[index]) {
								fatMes[index] += isNaN(parseFloat(line.text))
									? 0
									: parseFloat(line.text);
							} else {
								fatMes[index] = isNaN(parseFloat(line.text))
									? 0
									: parseFloat(line.text);
							}
							if (index == 0) {
								fatMes[index] = 'Faturamento';
							}
						});
					});
				}

				// Monta a linha Faturamento com os totais dos meses
				let faturamentoTotal = [];
				fatMes.forEach((item) => {
					faturamentoTotal.push({
						text: typeof item == 'string' ? item : item.toFixed(2),
						bold: true,
						fontSize: bodyTableFontSize,
					});
				});

				// Monta a linha Comissão com os totais das comissões por mês
				let comissao = [];
				if (this.comissao > 0) {
					fatMes.forEach((item) => {
						comissao.push({
							text:
								typeof item == 'string' && item != '0.00'
									? 'Comissão'
									: ((item * this.comissao) / 100).toFixed(2),
							bold: true,
							fontSize: bodyTableFontSize,
						});
					});
				}

				// Monta a variável docDefition com as informações da tabela
				// que servirá de parâmetro para a classe pdfmake que monta a tabela no final
				var docDefinition = {
					pageSize: 'A4',
					pageOrientation: 'landscape',
					content: [
						{
							text: [
								{
									text:
										'CONTROLE DE COMISSÃO DE VENDAS / ' +
										this.ano,
									fontSize: firstHeaderFontSize,
									bold: true,
								},
							],
						},
						' ',
						{
							text: [
								{
									text: vendedor,
									fontSize: secondHeaderFontSize,
								},
							],
						},
						' ',
						{
							layout: 'lightHorizontalLines', // optional
							table: {
								// headers are automatically repeated if the table spans over multiple pages
								// you can declare how many rows should be treated as headers
								headerRows: 1,
								widths: 'auto',
								body: [
									[
										{
											text: 'empresa',
											bold: true,
											fontSize: bodyTableFontSize,
										},
										{
											text: 'Jan',
											bold: true,
											fontSize: bodyTableFontSize,
										},
										{
											text: 'Fev',
											bold: true,
											fontSize: bodyTableFontSize,
										},
										{
											text: 'Mar',
											bold: true,
											fontSize: bodyTableFontSize,
										},
										{
											text: 'Abr',
											bold: true,
											fontSize: bodyTableFontSize,
										},
										{
											text: 'Mai',
											bold: true,
											fontSize: bodyTableFontSize,
										},
										{
											text: 'Jun',
											bold: true,
											fontSize: bodyTableFontSize,
										},
										{
											text: 'Jul',
											bold: true,
											fontSize: bodyTableFontSize,
										},
										{
											text: 'Ago',
											bold: true,
											fontSize: bodyTableFontSize,
										},
										{
											text: 'Set',
											bold: true,
											fontSize: bodyTableFontSize,
										},
										{
											text: 'Out',
											bold: true,
											fontSize: bodyTableFontSize,
										},
										{
											text: 'Nov',
											bold: true,
											fontSize: bodyTableFontSize,
										},
										{
											text: 'Dez',
											bold: true,
											fontSize: bodyTableFontSize,
										},
									],
								],
							},
						},
					],
				};

				// Adiciona as linhas de faturamento das empresas à estrutura da tabela na variável docDefinition
				faturamentoEmpresas.forEach((element) => {
					docDefinition.content[4].table.body.push(element);
				});

				// Adiciona a linha de totalização do faturamento mês a mês à estrutura da tabela na variável docDefinition
				docDefinition.content[4].table.body.push(faturamentoTotal);

				// Adiciona a linha de totalização da comissão mês a mês à estrutura da tabela na variável docDefinition
				if (this.comissao > 0)
					docDefinition.content[4].table.body.push(comissao);

				// Se o botão clicado foi o gera('pdf') gera o arquivo pdf para download
				if (tipo == 'pdf') {
					pdfMake
						.createPdf(docDefinition)
						.download(
							'comissao_' +
								this.vendedor +
								'_' +
								this.ano +
								'.pdf'
						);
				}

				// Se o botão clicado foi o gera('xls') gera o arquivo xls para download
				if (tipo == 'xls') {
					// Cria um novo workbook
					const workbook = XLSX.utils.book_new();

					// Monta as linhas da empresa e os faturamentos mensais
					let linhaEmpresa = [];
					faturamentoEmpresas.forEach((empresa, empresaIndex) => {
						linhaEmpresa[empresaIndex] = [];
						empresa.forEach((item, itemIndex) => {
							let campo;
							if (item.text == ' - ') {
								campo = 0;
							} else if (
								typeof parseFloat(item.text) == 'number' &&
								!isNaN(parseFloat(item.text))
							) {
								campo = parseFloat(item.text);
							} else {
								campo = item.text;
							}

							linhaEmpresa[empresaIndex][itemIndex] = campo;
						});
					});

					// Monta a linha de totalização dos faturamentos por mês
					let linhaFaturamento = [];
					faturamentoTotal.forEach((item) => {
						linhaFaturamento.push(
							item.text == 'Faturamento'
								? item.text
								: parseFloat(item.text)
						);
					});

					// Monta a linha de totalização das comissões por mês
					let linhaComissao = [];
					comissao.forEach((item) => {
						linhaComissao.push(
							item.text == 'Comissão'
								? item.text
								: parseFloat(item.text)
						);
					});

					// Monta a estrutura da planilha
					let planilha = [
						['CONTROLE DE COMISSÃO DE VENDAS / ' + this.ano],
						[this.vendedor],
						[
							'empresa',
							'Jan',
							'Fev',
							'Mar',
							'ABr',
							'Mai',
							'Jun',
							'Jul',
							'Ago',
							'Set',
							'Out',
							'Nov',
							'Dez',
						],
					];

					// Insere as linhas das empresas com seus faturamentos mensais à estrutura da planilha
					linhaEmpresa.forEach((item) => {
						planilha.push(item);
					});

					// Insere a linha de totalização do faturamento por mês à estrutura da planilha
					planilha.push(linhaFaturamento);

					// Insere a linha de totalização da comissão por mês à estrutura da planilha
					planilha.push(linhaComissao);

					// Cria um novo worksheet
					const worksheet = XLSX.utils.aoa_to_sheet(planilha);

					// Adiciona o worksheet ao workbook
					XLSX.utils.book_append_sheet(
						workbook,
						worksheet,
						'Planilha1'
					);

					// Salva/Gera o arquivo XLSX para download
					XLSX.writeFile(
						workbook,
						'comissao_' + this.vendedor + '_' + this.ano + '.xlsx'
					);

					console.log('Planilha criada com sucesso!');
				}
			},
		},
	};
</script>
<style scoped>
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.1s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/sellers/comissao.vue